export const LOGIN_START = 'LOGIN_START'
export const LOGIN_SUCESSFUL = 'LOGIN_SUCESSFUL'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGOUT = 'LOGOUT'

export const CHECK_AUTH_STATE = 'CHECK_AUTH_STATE' 

export const ADD_APPLICATION = 'ADD_APPLICATION'
export const ADD_APPLICATION_SUCCESS = 'ADD_APPLICATION_SUCCESS'
export const ADD_APPLICATION_FAILED = 'ADD_APPLICATION_FAILED'
export const ADD_APPLICATION_START = 'ADD_APPLICATION_START'

export const FETCH_APPLICATIONS_START = 'FETCH_APPLICATIONS_START'
export const FETCH_APPLICATIONS_SUCCESS = 'FETCH_APPLICATIONS_SUCCESS'
export const FETCH_APPLICATIONS_FAILED = 'FETCH_APPLICATIONS_FAILED'

export const PROCESS_APPLICATION_INIT = 'PROCESS_APPLICATION_INIT'
export const PROCESS_APPLICATION_START = 'PROCESS_APPLICATION_START'
export const PROCESS_APPLICATION_SUCCESS = 'PROCESS_APPLICATION_SUCCESS'
export const PROCESS_APPLICATION_FAILED = 'PROCESS_APPLICATION_FAILED'

export const DELETE_APPLICATION_START = 'DELETE_APPLICATION_START'
export const DELETE_APPLICATION_SUCCESS = 'DELETE_APPLICATION_SUCCESS'
export const DELETE_APPLICATION_FAILED = 'DELETE_APPLICATION_FAILED'

export const GET_STREETVIEW_START = 'GET_STREETVIEW_START'
export const GET_STREETVIEW_SUCCESS = 'DELETE_APPLICATION_SUCCESS'
export const GET_STREETVIEW_FAILED = 'DELETE_APPLICATION_FAILED'


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js